import { useCallback } from "react";
import { useScheduleRules } from "../../ScheduleEmail/hooks/useScheduleRules";

export const useFormData = (sendTo: any[], initialFilesIds: string[]) => {
  const { getScheduleRules } = useScheduleRules();

  const getFormData = useCallback(
    (data: any, scheduleValues?: any) => {
      const request: any = {
        receivers: [],
      };

      for (const [key, value] of Object.entries(data)) {
        if (value === undefined || value === null) {
          continue;
        }

        if (key === "sendTo") {
          data.sendTo.forEach((item: string) => {
            const val = sendTo.find((data: any) => data.i.toString() === item);

            if (val) {
              const receiver: any = { email: val.email };

              if (val.id) {
                receiver.receiverId = val.id;
              }

              request.receivers.push(receiver);
            }
          });

          continue;
        }

        if (key === "fileList") {
          const removedAttachmentIds: string[] = [];
          const fileItemIds: string[] = [];

          data.fileList.forEach((item: any) => {
            item.originFileObj && fileItemIds.push(item.response);
          });

          initialFilesIds.forEach((id: string) => {
            const findId = data.fileList.find(
              (item: any) => item.response === id
            );

            !findId && removedAttachmentIds.push(id);
          });

          request.removedAttachmentIds = removedAttachmentIds;

          request.fileItemIds = fileItemIds;

          continue;
        }

        request[key] = data[key];
      }

      const scheduleRules = getScheduleRules(scheduleValues);

      return { ...request, scheduleRules };
    },
    [initialFilesIds, sendTo, getScheduleRules]
  );

  return { getFormData };
};
